export default "__VITE_ASSET__CwqFnJwx__"